<template>

  <!-- <a
    style="background:black; width:60px; padding:0; border-radius:100%; height:60px; display:inline-flex; align-items:center; justify-content:center;">
    <span class="app-name d-block">
      <span>}</span>
    </span>
    <span class="app-name d-block">
      <span class="current-title-mobile"><span class="brace">{</span></span>
    </span>
  </a> -->
  <a href="#" class="logo-login" >
    <span class="app-name">Bracket</span>
  </a>

</template>
<script>
  export default {

  }

</script>
